// extracted by mini-css-extract-plugin
module.exports = {"button":"lab-cta-practice_button__Vl0OO","small-btn":"lab-cta-practice_small-btn__NuBbt"};